import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, IMultiChoiceButtonOption, MultiChoice } from '@ruby-labs/ui-core-kit';


import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';

import { NextButton } from 'components/next-button';
import { FloatedButton } from 'components/floated-button';
import { getMultiChoiceSelected } from 'helpers/get-multichoice-button-select-options';

export const Motivation = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageConfiguration } = useContext(BaseContext);

    const pageKey = LocalStorageKeys[RoutePath.Motivation];

    const { pageValue, setPageValue } = useLocalStorage({
        key: pageKey,
        defaultValue: [],
    });

    const { pageValue: userAnswer, setPageValue: setUserAnswer } = useLocalStorage({
        key: `${pageKey}-other-userAnswer`,
        defaultValue: '',
    });

    const options: IMultiChoiceButtonOption[] = [
        {
            value: 'health',
            label: t('motivation-option-health')
        },
        {
            value: 'look-better',
            label: t('motivation-option-look-better')
        },
        {
            value: 'feel-more-confident',
            label: t('motivation-option-feel-more-confident')
        },
        {
            value: 'get-stronger',
            label: t('motivation-option-get-stronger')
        },
        {
            value: 'increase-energy',
            label: t('motivation-option-increase-energy')
        },
        {
            value: 'recover',
            label: t('motivation-option-recover')
        },
        {
            value: 'improve-sports-performance',
            label: t('motivation-option-improve-sports-performance')
        },
        {
            value: 'other',
            label: t('motivation-option-other'),
            placeholder: 'Add your answer here',
            userAnswer,
            setUserAnswer,
        },
    ];

    const handleClick = () => {
        const { values, labels } = getMultiChoiceSelected(pageValue);

        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('motivation-title'), value: labels },
        });

        pageConfiguration.handleOnPageComplete({
            value: values,
            userAnswer: values.includes('other') ? userAnswer?.toString()?.trim() : ''
        });
    };

    return (
        <>
            <Heading title={t('motivation-title')} subtitle={t('motivation-subtitle')} />

            <MultiChoice
                options={options}
                deselectWhenValues={['none']}
                selectedOptions={pageValue}
                onSelect={setPageValue} />

            <FloatedButton floated={pageValue.length} withGradient>
                <NextButton onClick={handleClick} disabled={!pageValue.length} />
            </FloatedButton>
        </>
    );
};
